import React, {Component} from 'react';
import View from './View';

export default class extends Component {
    constructor(props) {
        super(props);

        this.state = {
            userType: this.props.userType
        };
    }

    render() {
        return (
            <View
              location={this.props.location}
              userType={this.props.userType}
            />
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Menu/index.js